
const initialState = {
    companyState: {}
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'getinfo':
            localStorage.company_detail = JSON.stringify(action.content);
            return Object.assign({}, state, { companyState: action.content });
    }
    return state;
}

// export default function (state = initialState, action) {
//     switch (action.type) {
//         case 'getinfo': {
//             const { content } = action.payload;
//             return {
//                 ...state,
//                 companyinfo: content
//             };
//         }

//         default:
//             return state;
//     }
// }




// WEBPACK FOOTER //
// ./src/redux/reducers/company.js